<template>
  <div class="dashboard-cnt">
    <header>
      <menuIcon />
      <span class="h_logo">
        <img src="../assets/images/logo.svg" alt="Ads91" />
      </span>
      <button class="button" @click="$router.push('/create-ad')">
        <createAdIcon />
        Create Ad
      </button>
    </header>
    <ul class="dashboard-tab">
      <li
        :class="{ 'active-tab': currentTab == 'yourads' }"
        @click="ToggleTab('yourads')"
      >
        Your Ads
      </li>
      <li
        :class="{ 'active-tab': currentTab == 'wallet' }"
        @click="ToggleTab('wallet')"
      >
        Wallet
      </li>
    </ul>

    <section class="mid-cnt">
      <your-ads
        v-if="currentTab == 'yourads'"
        @createAd="$router.push('/create-ad')"
      />
      <wallet-info v-if="currentTab == 'wallet'" />
    </section>
    <loadingIcon v-if="loading" />
    <Toaster :dataValue="toasterData" />
  </div>
</template>

<script>
import WalletInfo from "../components/walletInfo";
import YourAds from "../components/yourAds";
import menuIcon from "../components/icons/menuIcon";
import createAdIcon from "../components/icons/createAdIcon";
import { SessionHelper } from "../utils/session";
import loadingIcon from "../components/icons/loadingIcon";
import Toaster from "../components/Toaster";

export default {
  name: "Dashboard",
  components: {
    WalletInfo,
    YourAds,
    menuIcon,
    createAdIcon,
    loadingIcon,
    Toaster,
  },
  mounted() {
     if(SessionHelper.getCookie("loadWallet") === 'true'){
       this.adsList();
       this.walletDetail();
     }else{
       this.loading = false
     }
  },
  data() {
    return {
      currentTab: "yourads",
      loading: true,
      toasterData:{}
    };
  },
  methods: {
    ToggleTab(tab) {
      this.currentTab = tab;
    },
     walletDetail() {
      this.$store.dispatch({ type: "getWalletHistory" }).then((data) => {
        console.log("=data history=", data);
        if (data.httpStatus === 200) {
          this.$store.commit("AdsTransaction", data.data);
          SessionHelper.setCookie("loadWallet", "false");
          this.loading = false;
        } else {
          SessionHelper.setCookie("loadWallet", "false");
          this.toasterData = {
            status: true,
            msg: data.message,
            timeoutMs: "5000",
            color: "#000",
          };
          this.loading = false;
        }
      });
    },
    adsList() {
      this.$store.dispatch({ type: "Adslist" }).then((data) => {
        if (data.httpStatus === 200) {
          this.$store.commit("adsList", data.data);
          SessionHelper.setCookie("loadWallet", "false");
          this.loading = false;
        } else {
          SessionHelper.setCookie("loadWallet", "false");
          this.toasterData = {
            status: true,
            msg: data.message,
            timeoutMs: "5000",
            color: "#000",
          };
          this.loading = false;
        }
      });
    },
  },
};
</script>
